export const TEAMS_PROVIDER_NAME = 'Microsoft Teams';

export const TEAMS_PROVIDER_KEY = 'microsoft-teams';

export const TEAMS_UNIFIED_OAUTH_CATEGORY = 'all';

export const TEAMS_SEND_MESSAGE_OAUTH_CATEGORY = 'send-message';

export const TEAMS_VOC_OAUTH_CATEGORY = 'voc';

export const TEAMS_AGENT_OAUTH_CATEGORY = 'agent';

export const TEAMS_UNFURL_OAUTH_CATEGORY = 'unfurl';

export const TEAMS_UNIFIED_BASE_REDIRECT_PATH = '/admin/integrations';

export const TEAMS_OVERVIEW_HELP_URL = 'https://support.pendo.io/hc/articles/51216976706971-Overview-of-Microsoft-Teams-integrations-with-Pendo';

export const TEAMS_PROVIDER_DESCRIPTION_KEY = 'integrationsBlade.unifiedSetup.teamsProviderDescription';

export const TEAMS_BUNDLED_OAUTH_CATEGORIES = new Set([
    TEAMS_AGENT_OAUTH_CATEGORY,
    TEAMS_SEND_MESSAGE_OAUTH_CATEGORY,
    TEAMS_UNFURL_OAUTH_CATEGORY,
    TEAMS_VOC_OAUTH_CATEGORY,
]);

export const TEAMS_BUNDLED_CHANNEL_POSTING_CATEGORIES = new Set();

export function isBundledTeamsIntegration (integration) {
    return TEAMS_BUNDLED_OAUTH_CATEGORIES.has(integration.oauth?.uriConfig?.category);
}

export const TEAMS_BUNDLE = {
    providerName: TEAMS_PROVIDER_NAME,
    providerKey: TEAMS_PROVIDER_KEY,
    unifiedOauthCategory: TEAMS_UNIFIED_OAUTH_CATEGORY,
    baseRedirectPath: TEAMS_UNIFIED_BASE_REDIRECT_PATH,
    overviewHelpUrl: TEAMS_OVERVIEW_HELP_URL,
    providerDescriptionKey: TEAMS_PROVIDER_DESCRIPTION_KEY,
    channelDisclaimerKey: '',
    bundledOauthCategories: TEAMS_BUNDLED_OAUTH_CATEGORIES,
    channelPostingCategories: TEAMS_BUNDLED_CHANNEL_POSTING_CATEGORIES,
    isBundledIntegration: isBundledTeamsIntegration,
};
